import React from 'react';
import { Main } from './components';

// Componente principal de Carritos (listado y acciones)
export const Carts: React.FC = () => {
  return (
    <>
      <Main />
    </>
  );
};

export default Carts;
